import styled from '@emotion/styled';

export const SliderContainer = styled.div`
	position: relative;
	width: 100%;
	height: 0.75rem;
	background: var(--border-color);
	margin: 0.75rem;
	cursor: pointer;
`;

export const Track = styled.div`
	position: absolute;
	height: 100%;
	background: var(--blue);
	z-index: 1;
	left: ${(props) => props.left}%;
	right: ${(props) => props.right}%;

	body[dir='rtl'] & {
		left: ${(props) => props.right}%;
		right: ${(props) => props.left}%;
	}
`;

export const Thumb = styled.div`
	position: absolute;
	width: 2.25rem;
	height: 2.25rem;
	border-radius: 50%;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	top: 50%;
	left: ${(props) => props.left}%;
	transform: translate(-50%, -50%);
	z-index: 2;
	background: var(--white);
	border: 4px solid ${(props) => (props.disabled ? 'var(--border-color)' : 'var(--blue)')};
	user-select: none;

	body[dir='rtl'] & {
		left: unset;
		right: ${(props) => props.left}%;
		transform: translate(50%, -50%);
	}
`;
